import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  pin: {
    width: 100,
    height: 100,
    d: `M48.654,3.964C33.091,4.618,20.117,17.1,18.871,32.627c-0.53,6.603,1.03,12.792,4.042,18.043
			l25.706,44.596c0.613,1.064,2.149,1.064,2.762,0L77.086,50.67c2.623-4.572,4.144-9.855,4.144-15.503
			C81.231,17.472,66.515,3.214,48.654,3.964z M50,50.963c-8.673,0-15.704-7.031-15.704-15.704c0-8.673,7.031-15.704,15.704-15.704
			c8.673,0,15.704,7.031,15.704,15.704C65.704,43.932,58.673,50.963,50,50.963z`,
  },
});
